import axios from "axios";
import React, { useState, useEffect } from "react";
import { DownloadTableExcel } from "react-export-table-to-excel";
import moment from "moment";
import { APIURL } from "../../../Config";
import { toast } from "react-toastify";

function CorporateOwnership() {
  const token = localStorage.getItem("token");

  const tableCorporateOwnership = React.useRef(null);
  const [ownership, setOwnership] = useState([]);
  const [items, setItem] = useState([]);
  const email = localStorage.getItem("emailId");
  const [isLoader, setIsLoader] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [rejectionReason, setRejectionReason] = useState("");
  const [selectedStatus, setSelectedStatus] = useState(null);

  useEffect(() => {
    getOwnershipChangeRequest();
  }, []);

  const manageOwnershipStatus = (datas, status) => {
    setIsLoader(true);

    let data = {
      email: datas.upEmail,
      name: datas.upName,
      employercode: datas.ownerCorporate,
      ownerEmail: email,
      remark: rejectionReason,
      id: datas.id,
      mobile: datas.upMobile,
      status: status,
    };

    axios
      .request(`${APIURL}/corporate/employerownershipUpdate`, {
        method: "POST",
        data: data,
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        toast.success(response.data);
        getOwnershipChangeRequest();
        setIsLoader(false);
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };

  const getOwnershipChangeRequest = () => {
    setIsLoader(true);
    axios
      .request(`${APIURL}/ownershiprequest`, {
        method: "GET",
        headers: {
          Authentication: token,

          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setOwnership(response?.data);
        setIsLoader(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  };

  return (
    <div className="p-3">
      <div>
        <ul className="nav nav-tabs" id="myTabs" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className="nav-link active tab-item "
              id="profile-tab"
              data-bs-toggle="tab"
              data-bs-target="#profile"
              type="button"
              role="tab"
              aria-controls="profile"
              aria-selected="true"
            >
              Employer Ownership
            </button>
          </li>
        </ul>

        <div className="tab-content mt-3" id="myTabsContent">
          <div
            className={`modal ${showModal ? "d-block" : "d-none"}`}
            tabIndex="-1"
            role="dialog"
          >
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Rejection Reason</h5>
                  <button
                    type="button"
                    className="close"
                    onClick={() => setShowModal(false)}
                  >
                    <span>&times;</span>
                  </button>
                </div>
                <div className="px-3 py-2">
                  <textarea
                    className="form-control"
                    value={rejectionReason}
                    onChange={(e) => setRejectionReason(e.target.value)}
                    placeholder="Enter reason for rejection"
                  />
                </div>
                <div className="d-flex flex-row justify-content-between px-3 pb-2 gap-2">
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={() => {
                      manageOwnershipStatus(items, "Reject");
                      setShowModal(false);
                    }}
                  >
                    Submit
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setShowModal(false)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div
            className="tab-pane fade show active"
            id="profile"
            role="tabpanel"
            aria-labelledby="profile-tab"
          >
            <div className="pt-3">
              <div className="card">
                {/* Excel Download Button */}
                <DownloadTableExcel
                  filename="CorporateOwnership"
                  sheet="users"
                  currentTableRef={tableCorporateOwnership.current}
                >
                  <button
                    className="btn btn-success mb-3 mb-md-0 mt-3 ml-3"
                    style={{
                      width: "120px",
                      backgroundColor: "#66a725",
                    }}
                  >
                    Download
                  </button>
                </DownloadTableExcel>

                {/* Display Table */}
                <div className="p-3 pt-4">
                  <div className="table-responsive">
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th style={{ textAlign: "center" }}>Sr. No</th>
                          <th style={{ textAlign: "center" }}>
                            Change in ownership request raised on dt and time{" "}
                          </th>
                          <th style={{ textAlign: "center" }}>Employer name</th>
                          <th style={{ textAlign: "center" }}>
                            Employer Code{" "}
                          </th>
                          <th style={{ textAlign: "center" }}>Owner name</th>
                          <th style={{ textAlign: "center" }}>Owner Email</th>
                          <th style={{ textAlign: "center" }}>Owner Mobile</th>

                          <th style={{ textAlign: "center" }}>
                            New Owner name
                          </th>
                          <th style={{ textAlign: "center" }}>
                            New Owner Email
                          </th>
                          <th style={{ textAlign: "center" }}>
                            New Owner Mobile
                          </th>
                          <th style={{ textAlign: "center" }}>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {ownership.length > 0 ? (
                          ownership.map((item, index) => (
                            <tr key={`display-${item.id}`}>
                              <td style={{ textAlign: "center" }}>
                                {index + 1}
                              </td>
                              <td style={{ textAlign: "center" }}>
                                {item.entrydate
                                  ? moment(
                                      item.entrydate.replace(" IST", "+05:30"),
                                      "YYYY-MM-DD HH:mm:ss Z"
                                    ).format("DD-MM-YYYY, h:mm:ss A")
                                  : ""}
                              </td>
                              <td>{item.employerName}</td>
                              <td style={{ textAlign: "center" }}>
                                {item.ownerCorporate}
                              </td>
                              <td>{item.ownerName}</td>
                              <td>{item.ownerEmail}</td>
                              <td style={{ textAlign: "center" }}>
                                {item.ownermobile}
                              </td>

                              <td>{item.upName}</td>
                              <td>{item.upEmail}</td>
                              <td style={{ textAlign: "center" }}>
                                {item.upMobile}
                              </td>
                              <td style={{ width: "120px" }}>
                                <div className="d-flex">
                                  <button
                                    className={`btn ${
                                      item?.status === "Approve"
                                        ? "btn-success"
                                        : "btn-outline-success"
                                    }`}
                                    onClick={() => {
                                      setItem(item);
                                      manageOwnershipStatus(item, "Approve");
                                    }}
                                    disabled={item?.status === "Approve"}
                                  >
                                    Approve
                                  </button>
                                  <button
                                    className={`btn ml-2 ${
                                      item?.status === "Reject"
                                        ? "btn-danger"
                                        : "btn-outline-danger"
                                    }`}
                                    onClick={() => {
                                      setItem(item);
                                      // manageOwnershipStatus(item, "Rejected");

                                      setSelectedStatus("Reject");
                                      setShowModal(true);
                                    }}
                                    disabled={item?.status === "Reject"}
                                  >
                                    Rejected
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="13" style={{ textAlign: "center" }}>
                              No data available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Hidden Table for Download */}
                <table
                  className="table table-striped mt-3 "
                  style={{ display: "none" }}
                  ref={tableCorporateOwnership}
                >
                  <thead>
                    <tr>
                      <th style={{ textAlign: "center" }}>Sr. No</th>
                      <th style={{ textAlign: "center" }}>
                        Change in ownership request raised on dt and time{" "}
                      </th>
                      <th style={{ textAlign: "center" }}>Employer name</th>
                      <th style={{ textAlign: "center" }}>Employer Code </th>
                      <th style={{ textAlign: "center" }}>Owner name</th>
                      <th style={{ textAlign: "center" }}>Owner Email</th>
                      <th style={{ textAlign: "center" }}>Owner Mobile</th>

                      <th style={{ textAlign: "center" }}>New Owner name</th>
                      <th style={{ textAlign: "center" }}>New Owner Email</th>
                      <th style={{ textAlign: "center" }}>New Owner Mobile</th>
                      <th style={{ textAlign: "center" }}>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {ownership.length > 0 ? (
                      ownership.map((item, index) => (
                        <tr key={`display-${item.id}`}>
                          <td style={{ textAlign: "center" }}>{index + 1}</td>
                          <td style={{ textAlign: "center" }}>
                            {item.entrydate
                              ? moment(
                                  item.entrydate.replace(" IST", "+05:30"),
                                  "YYYY-MM-DD HH:mm:ss Z"
                                ).format("DD-MM-YYYY, h:mm:ss A")
                              : ""}
                          </td>

                          <td style={{ textAlign: "center" }}>
                            {item.employerName}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {item.ownerCorporate}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {item.ownerName}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {item.ownerEmail}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {item.ownermobile}
                          </td>

                          <td style={{ textAlign: "center" }}>{item.upName}</td>
                          <td style={{ textAlign: "center" }}>
                            {item.upEmail}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {item.upMobile}
                          </td>
                          <td style={{ textAlign: "center" }}>{item.status}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="13" style={{ textAlign: "center" }}>
                          No data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CorporateOwnership;
